module.exports = __webpack_public_path__ + "static/media/04-0205.3f9f6523.png";